import './FleetDisclaimer.scss';

const FleetDisclaimer = ({ fields }) => {
  return (
    <div className={'container fleet-disclaimer'}>
      <div className={'containerDisclamer'}>
        <p>{fields?.title?.value}</p>
      </div>
    </div>
  );
};

export default FleetDisclaimer;
